import type {
  HealthPlanClaimEditParams,
  HealthPlanClaimEditResult,
} from '@/api/health-plan';
import { confirm } from '@/lib/feedback';

interface ClaimEditMutation {
  mutateAsync: (
    params: HealthPlanClaimEditParams,
  ) => Promise<HealthPlanClaimEditResult>;
}

export async function claimEditHealthPlanWithConfirm(
  planId: string,
  claimEdit: ClaimEditMutation,
) {
  const result = await claimEdit.mutateAsync({ planId });
  if (result.status !== 'need_claim_patient') {
    return true;
  }

  const confirmed = await confirm({
    title: '加入患者池',
    body: result.message || '该患者尚未加入你的患者池，是否加入后修改方案？',
    confirmText: '加入并编辑',
  });
  if (!confirmed) {
    return false;
  }
  await claimEdit.mutateAsync({ planId, confirmAddPatient: true });
  return true;
}
